import Vue from 'vue';
import Router from 'vue-router';

import RouterGuard from '@/router/guard';

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import("@/views/login"),
      meta: {
        requires: 'guest',
      },
    },
    {
      path: '/register',
      component: () => import("@/views/register"),
      meta: {
        requires: 'guest',
      },
    },
    {
      path: '/tutor/:id',
      component: () => import("@/views/tutor"),
      props: true
    },
    {
      path: '/dashboard/assessments',
      component: () => import("@/views/assessments"),
      meta: {
        requires: 'authenticated',
      },
    },
    {
      path: '/dashboard/categories',
      component: () => import("@/views/categories"),
      meta: {
        requires: 'authenticated',
      },
    },
    {
      path: '/dashboard/create-assessment',
      component: () => import("@/views/create-assessment"),
      meta: {
        requires: 'authenticated',
      },
    },
    {
      path: '/dashboard/templates',
      component: () => import("@/views/templates"),
      meta: {
        requires: 'authenticated',
      },
    },
    {
      path: '/dashboard/templates/add',
      component: () => import("@/views/templates-add"),
      meta: {
        requires: 'authenticated',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // each matching route must be secured
  const failed = to.matched.some((record) => {
    const securityRequirement = record.meta.requires;

    if (securityRequirement) {
      // if blocked, expecting it to execute next() and return true
      return RouterGuard.block(securityRequirement, to, from, next);
    }
  });

  // nothing odd happened
  if (!failed) {
    next();
  }
});

export default router;
